export default {"src":"/_next/static/media/icon-logout.34d2594c.svg","height":16,"width":16};